<template>
  <div>
    <modal v-model="modal" :backdrop="false" size="max">
      <h4 slot="title" class="smalltitle">Approval EPCS</h4>
      <div class="block-body">
        <div class="item-block">
          <div class="item-date"><b>Date</b></div>
          <div class="item-doctor"><b>Doctor</b></div>
          <div class="item-action"><b>Action</b></div>
          <div class="item-dea"><b>DEA</b></div>
          <div class="item-dea"><b>Expire</b></div>
          <div class="item-user"><b>User</b></div>
        </div>
        <div class="item-block">
          <div class="item-date">{{ formatFullTime12Hour(requestPending.createdAt) }}</div>
          <div class="item-doctor">{{ requestPending.doctorName }}</div>
          <div class="item-action">{{ getActionName() }}</div>
          <div class="item-dea">{{ requestPending.user ? requestPending.user.dea : 'N/A' }}</div>
          <div class="item-dea">{{ (requestPending.user &&  requestPending.user.expiration_date) ? formatTime(requestPending.user.expiration_date) : 'N/A' }}</div>
          <div class="item-user">{{ requestPending.user ? requestPending.user.fullName : 'N/A' }}</div>
        </div>
        <div class="item-block" v-for="(item, index) in histories">
          <div class="item-date">{{ formatFullTime12Hour(item.createdAt) }}</div>
          <div class="item-doctor">{{ item.doctorName }}</div>
          <div class="item-action"> {{getHistoryAction(index)}}</div>
          <div class="item-dea">{{ item.user ? item.user.dea : 'N/A' }}</div>
          <div class="item-dea">{{ (requestPending.user &&  requestPending.user.expiration_date) ? formatTime(requestPending.user.expiration_date) : 'N/A' }}</div>
          <div class="item-user">{{ item.user ? item.user.fullName : 'N/A' }}</div>
        </div>
        <div class="clearfix"></div>
        <div>
          <label class="text-confirmation"><input v-model="isConfirmed" :value="true" type="checkbox">I attest that I
            have verified {{ requestPending.doctorName }}'s credentials and ID proofing process to be accurate and up to
            date and that the above provider is fit to get EPCS function</label>

        </div>

      </div>
      <div slot="footer">
        <div class="col-md-6" style="text-align: left">
          <div class="block-2fa">
            <input v-model="declineReason" placeholder="Reason" type="text">
          </div>
          <button class="btn btn-default" type="button" @click.prevent="declineRequest" :disabled="!declineReason">
            <i v-if="isProcessing" class="fas fa-spinner fa-spin"></i>Deny
          </button>
        </div>
        <div class="col-md-6">

          <div class="block-2fa">
            <input v-model="codeConfirmation" placeholder="Enter 2FA" type="text">
          </div>
          <button class="btn btn-default" :disabled="!isConfirmed" type="button" @click.prevent="approveRequest"><i v-if="isProcessing"
                                                                                           class="fas fa-spinner fa-spin"></i>Approve
          </button>
          <button class="btn btn-default" type="button" @click.prevent="closeModal">Close</button>
        </div>
      </div>
    </modal>
  </div>

</template>

<script>

import httpClient from '@/client'
import CommonMixin from '@/mixins/general/CommonMixin.vue'

export default {
  name: 'ModalApprovalEpcs',
  components: {},
  props: {
    doctor: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      modal: false,
      requestPending: {},
      isConfirmed: false,
      codeConfirmation: '',
      isProcessing: false,
      histories: [],
      declineReason: ''
    }
  },
  computed: {},
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }
  },
  updated () {
  },
  mounted () {
    this.initData()
    this.modal = true
  },
  beforeDestroy () {
  },
  methods: {
    async declineRequest () {
      if (this.isProcessing) {
        return
      }
      try {
        this.isProcessing = true
        let response = await httpClient.post(`/surescript/decline-request/${this.doctor.id}`, { declineReason: this.declineReason })
        this.isProcessing = false
        if (response.data.s !== 200) {
          this.alertError(response.data.msg)
          return
        }
        if (response.data.isFinished) {
          this.$emit('finishApproval', {})
        }
        this.modal = false
      } catch (e) {
        this.isProcessing = false
        this.alertException(e)
      }
    },
    async approveRequest () {
      if (!this.codeConfirmation) {
        this.alertError('Please enter 2FA code')
        return
      }
      if (this.isProcessing) {
        return
      }
      if (!this.isConfirmed) {
        return
      }
      try {
        this.isProcessing = true
        let response = await httpClient.post(`/surescript/approval-request/${this.doctor.id}`, { twoFactorToken: this.codeConfirmation })
        this.isProcessing = false
        if (response.data.s !== 200) {
          this.alertError(response.data.msg)
          return
        }
        if (response.data.isFinished) {
          this.$emit('finishApproval', {})
        }
        this.modal = false
      } catch (e) {
        this.isProcessing = false
        this.alertException(e)
      }
    },
    getHistoryAction (index) {
      if (this.histories.length === 1) {
        index = 1
      }
      let array = ['Second', 'First']
      return `${array[index]} Approval`
    },
    getActionName () {
      return `${this.requestPending.action === 'add' ? 'Add' : 'Remove'} Controlled Substance`
    },
    async initData () {
      try {
        if (!this.doctor) {
          return
        }
        let response = await httpClient.get(`/surescript/approval-request/${this.doctor.id}`)
        if (response.data.s !== 200) {
          this.alertError(response.data.msg)
          this.modal = false
          return
        }
        this.requestPending = response.data.requestPending ? response.data.requestPending : {}
        this.histories = response.data.histories
      } catch (e) {
        this.alertException(e)
        this.modal = false
      }
    },
    closeModal () {
      this.modal = false
    }

  }
}
</script>
<style scoped="">
.item-block {
  display: block;
  width: 100% !important;
  clear: both;
}

.item-date {
  width: 15% !important;
  float: left;
  display: block;
  min-height: 1px;
}

.item-doctor {
  width: 25% !important;
  float: left;
  display: block;
  min-height: 1px;
}

.item-action {
  width: 25% !important;
  float: left;
  display: block;
  min-height: 1px;
}

.item-user {
  width: 15% !important;
  float: left;
  display: block;
  min-height: 1px;
}
.item-dea {
  width: 10% !important;
  float: left;
  display: block;
  min-height: 1px;
}

.text-confirmation {
  margin-top: 10px;
  font-size: 14px;
  font-weight: bold;
  font-style: italic;
}

.block-2fa {
  width: 200px;
  display: inline-block;
  margin-right: 10px
}

</style>
